import router from './router'
import { Route } from 'vue-router'
import UserModule from '@/store/modules/user'
import { Loading } from 'element-ui'
import { setScreenLoading } from './utils/spinner'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'

const whiteListRoutePaths = ['/login', '/auth-redirect', '/forgot-password', '/reset-password', '/404', '/500']
const whiteListRouteNames = ['tracking']

// One-shot guard: the silent session restore should only run on app boot.
let sessionRestoreAttempted = false

router.beforeEach(async(to: Route, _: Route, next: any) => {
  if (to.path !== '/login') setScreenLoading(true)

  if (store) {
    const UserStoreModule = getModule(UserModule, store)

    // After a reload the in-memory token is empty even for a logged-in user
    // (HttpOnly cookie); try one silent refresh before treating them as logged out.
    if (!UserStoreModule.isAuthenticated && !sessionRestoreAttempted) {
      sessionRestoreAttempted = true
      await UserStoreModule.restoreSession()
    }

    if (UserStoreModule.isAuthenticated) {
      if (to.path === '/login' && !to.query.logout) {
        next({ path: '/' })
      }
      next()
    } else {
      const routeIsWhitelist = whiteListRoutePaths.includes(to.path) || whiteListRouteNames.includes(to.name as string)
      if (routeIsWhitelist) {
        next()
      } else {
        next(`/login?redirect=${to.path}&logout=1`)
      }
    }
  }
})

router.afterEach(() => {
  setTimeout(() => {
    Loading.service({}).close()
  },
  500)
})
